<template>
    <div class="customer-section-counts">
        <div class="d-flex align-items-center gap-2 flex-wrap">
            <strong class="small">{{ __('tools.testing.snapshots.limits.modal.heading') }}</strong>

            <template v-if="status === COUNTS_LOADED && counts !== null">
                <DBadge :color="counts.exceedsCustomerLimit ? 'danger' : 'success'">
                    {{ __('tools.testing.snapshots.limits.modal.customers', { count: counts.customers, limit: counts.customerLimit }) }}
                </DBadge>
                <DBadge :color="counts.exceedsContractLimit ? 'danger' : 'success'">
                    {{ __('tools.testing.snapshots.limits.modal.contracts', { count: counts.contracts, limit: counts.contractLimit }) }}
                </DBadge>
            </template>

            <small
                v-else-if="status === COUNTS_LOADING"
                class="text-muted"
            >
                <DIcon name="timer-sand" />
                {{ __('tools.testing.snapshots.limits.modal.counting') }}
            </small>

            <small
                v-else-if="status === COUNTS_FAILED"
                class="text-warning"
            >
                <DIcon name="alert-outline" />
                {{ __('tools.testing.snapshots.limits.modal.count_failed', { customers: customerLimit, contracts: contractLimit }) }}
            </small>

            <small
                v-else
                class="text-muted"
            >
                {{ __('tools.testing.snapshots.limits.modal.not_counted', { customers: customerLimit, contracts: contractLimit }) }}
            </small>
        </div>

        <!-- counts.isRefused is the server's verdict; never re-derive it from the two numbers. -->
        <DAlert
            v-if="status === COUNTS_LOADED && counts !== null && counts.isRefused"
            color="danger"
            class="mt-2 mb-0 py-2"
        >
            {{ __('tools.testing.snapshots.limits.modal.over_limits') }}
        </DAlert>
        <small
            v-else-if="status === COUNTS_LOADED && counts !== null"
            class="text-muted"
        >
            {{ __('tools.testing.snapshots.limits.modal.within_limits') }}
        </small>
    </div>
</template>

<script setup>

import { computed } from 'vue'
import { __ } from '~@/Composables/translation'
import { COUNTS_FAILED, COUNTS_LOADED, COUNTS_LOADING } from '~@/Composables/snapshotSectionCounts'

const props = defineProps({
    // 'idle' | 'loading' | 'loaded' | 'failed' -- see useSnapshotSectionCounts().
    status: {
        type: String,
        required: true
    },
    // The server's CustomerSectionSize::toArray(), or null while there is no answer to show.
    counts: {
        type: Object,
        default: null
    },
    // The configured caps (tenant-snapshots.limits), so they can be named before anything has been counted.
    limits: {
        type: Object,
        default: () => { return {} }
    },
})

const customerLimit = computed(() => props.counts?.customerLimit ?? props.limits.customers ?? '?')
const contractLimit = computed(() => props.counts?.contractLimit ?? props.limits.contracts ?? '?')

</script>

<style lang="scss" scoped>
.customer-section-counts {
    width: 100%;
}
</style>
